<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form :inline="true" label-position="top" label-width="100px" class="custom-form">
        <el-form-item :label="$t('member.memberName')" class="custom-item">
          <el-input
            :placeholder="$t('member.memberName')"
            v-model="listQuery.memberName"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item v-if="opType=='charge'" :label="$t('record.shiftNo')" class="custom-item">
          <el-input
            :placeholder="$t('record.shiftNo')"
            v-model="listQuery.classes"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item :label="$t('company.companyName')" class="custom-item">
          <el-select
            v-model="listQuery.companyId"
            :placeholder="$t('company.companyName')"
            class="filter-item"
          >
            <el-option label="全部" value="0" />
            <el-option
              v-for="item in companyLists"
              :key="item.key"
              :label="item.companyName"
              :value="item.companyId"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="opType=='amount'" :label="$t('record.amtType')" class="custom-item">
          <el-select
            v-model="listQuery.amtType"
            :placeholder="$t('record.amtType')"
            class="filter-item"
          >
            <el-option label="全部" value="0" />
            <el-option
              v-for="(item,index) in amtTypes"
              :key="index"
              :label="item.title"
              :value="item.type"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-else-if="opType=='point'" :label="$t('record.amtType')" class="custom-item">
          <el-select
            v-model="listQuery.pointType"
            :placeholder="$t('record.amtType')"
            class="filter-item"
          >
            <el-option label="全部" value="0" />
            <el-option
              v-for="(item,index) in pointTypes"
              :key="index"
              :label="item.title"
              :value="item.type"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-else-if="opType=='charge'||opType=='refund'||opType=='close'"
          :label="$t('record.amtType')"
          class="custom-item"
        >
          <el-select
            v-model="listQuery.sourceType"
            :placeholder="$t('record.amtType')"
            class="filter-item"
          >
            <el-option label="全部" value="0" />
            <el-option
              v-for="(item,index) in sourceTypes"
              :key="index"
              :label="item.title"
              :value="item.type"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="opType=='charge'" :label="$t('record.payTypeName')" class="custom-item">
          <el-select
            v-model="listQuery.payTypeId"
            :placeholder="$t('record.payTypeName')"
            class="filter-item"
          >
            <el-option label="全部" value="0" />
            <el-option
              v-for="(item,index) in payLists"
              :key="index"
              :label="item.payTypeName"
              :value="item.payTypeId"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="opType=='charge'||opType=='refund'||opType=='close'"
          :label="$t('company.station')"
          class="custom-item"
        >
          <el-select
            v-model="listQuery.optStationId"
            :placeholder="$t('company.station')"
            class="filter-item"
          >
            <el-option v-if="isAllStation === 1" label="全部" value="0" />
            <el-option
              v-for="(item,index) in stationLists"
              :key="index"
              :label="item.stationName"
              :value="item.stationId"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="opType=='charge'" label="充值类型" prop="stationName" class="custom-item">
          <el-select v-model="listQuery.cate" placeholder="充值类型">
            <el-option label="全部" value />
            <el-option label="充值记录" value="1" />
            <el-option label="退款记录" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="日期选择" class="custom-item">
          <el-date-picker
            v-model="btime"
            :default-time="['00:00:00','23:59:59']"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item label="快速选择时间" class="custom-item">
          <el-select v-model="quickTime" placeholder="时间" @change="changeVal">
            <el-option label="今天" value="1" />
            <el-option label="昨天" value="2" />
            <el-option label="近三天" value="3" />
            <el-option label="近七天" value="4" />
            <el-option label="本月" value="5" />
          </el-select>
        </el-form-item>
      </el-form>
      <p style="text-align:center">
        <el-button
          v-waves
          v-if="opType==='charge'||opType==='refund'"
          class="filter-item"
          type="info"
          icon="el-icon-document"
          @click="handleToExcel"
        >导出</el-button>
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
        >{{ $t('table.search') }}</el-button>
      </p>
    </div>
    <Amount v-if="opType=='amount'" :alist.sync="list" :list-loading.sync="listLoading" />
    <Point v-else-if="opType=='point'" :alist.sync="list" :list-loading.sync="listLoading" />
    <Charge
      v-else-if="opType=='charge'"
      :alist.sync="list"
      :total-charge.sync="totalCharge"
      :total-gift.sync="totalGift"
      :cnt.sync="cnt"
      :list-loading.sync="listLoading"
    />
    <Refund
      v-else-if=" opType=='refund'"
      :alist.sync="list"
      :total-refund.sync="totalRefund"
      :list-loading.sync="listLoading"
    />
    <Closes v-else-if=" opType=='close'" :alist.sync="list" :list-loading.sync="listLoading" />
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { recordList, fetchTotalRefund, fetchTotalCharge } from '@/api/record'
import { listStationSimple } from '@/api/station'
import { memberList } from '@/api/member'
import { listPayType } from '@/api/setting'
import { fetchList } from '@/api/company'
import Amount from '@/components/Record/Amount'
import Charge from '@/components/Record/Charge'
import Point from '@/components/Record/Point'
import Closes from '@/components/Record/Closes'
import Refund from '@/components/Record/Refund'
import waves from '@/directive/waves' // 水波纹指令
import { getDateOfDay, getYesterdayArr, getCurMonthRange } from '../../utils'
import { getDateOfMonth } from '../../utils'
import { rechargeRecordToExcel, refundRecordToExcel } from '@/api/download'
import { downloadFile } from '@/utils/file'
import { getEmpInfo } from '@/utils/auth'
const typeOptions = [
  { value: 1, label: '总帐支付' },
  { value: 2, label: '子账支付' }
]
const statusMap = { 1: '加油', 2: '充值', 3: '退款' }
const amtType = [
  { type: 1, title: '加油' },
  { type: 2, title: '充值' },
  { type: 3, title: '退款' }
]
const pointType = [{ type: 1, title: '得分' }, { type: 2, title: '消费' }]
const sourceType = [{ type: 1, title: '平台' }, { type: 2, title: '站点' }]
export default {
  name: 'Index',
  directives: {
    waves
  },
  components: {
    Amount,
    Charge,
    Point,
    Closes,
    Refund
  },
  filters: {
    statusFilter (status) {
      return statusMap[status]
    },
    typeFilter (type) {
      for (const key in typeOptions) {
        if (typeOptions[key].value === type) {
          return typeOptions[key].label
        }
      }
    }
  },
  props: {
    opType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      totalRefund: 0,
      totalCharge: 0,
      totalGift: 0,
      cnt: 0,
      totalAmt: 0,
      stationLists: [],
      list: [],
      total: null,
      listLoading: true,
      btime: getDateOfDay(0),
      listQuery: {
        page: 1,
        memberName: '',
        limit: 20,
        status: '',
        memberId: '0',
        companyId: '0',
        amtType: '',
        pointTypes: '',
        sourceType: '',
        payTypeId: '0',
        classes: '',
        optStationId:
          getEmpInfo().isAllStation === 0 ? getEmpInfo().stationId : '',
        cate: '',
        optEmpId: ''
      },
      isAllStation: getEmpInfo().isAllStation,
      amtTypes: amtType,
      pointTypes: pointType,
      sourceTypes: sourceType,
      showReviewer: false,
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      dialogPvVisible: false,
      types: typeOptions,
      statusType: statusMap,
      payLists: [],
      companyLists: [],
      restaurants: [],
      quickTime: ''
    }
  },
  created () {
    // 获取选择列表
    fetchList({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data) {
        const obj = row.data.items
        for (const key in obj) {
          this.companyLists.push({
            companyId: obj[key].companyId,
            companyName: obj[key].companyName
          })
        }
      }
    })
    if (
      this.opType === 'charge' ||
      this.opType === 'refund' ||
      this.opType === 'close'
    ) {
      listPayType({ status: 1 }).then(response => {
        const row = response.data
        if (row.data) {
          const obj = row.data
          for (const key in obj) {
            this.payLists.push({
              payTypeId: obj[key].payTypeId,
              payTypeName: obj[key].payTypeName
            })
          }
        }
      })
      listStationSimple({ ps: 100 }).then(response => {
        const row = response.data
        if (row.data) {
          const obj = row.data
          for (const key in obj) {
            this.stationLists.push({
              stationId: obj[key].stationId,
              stationName: obj[key].stationName
            })
          }
        }
      })
    }
    this.handleFilter()
  },
  methods: {
    querySearchAsync (queryString, cb) {
      const results = queryString ? this.memberList() : this.restaurants
      const res = []
      for (const key in results) {
        res.push({
          value: results[key].memberName,
          memberId: results[key].memberId
        })
      }
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(res)
      }, 3000 * Math.random())
    },
    handleSelect (item) {
      this.listQuery.memberId = item.memberId
      this.listQuery.memberName = item.value
    },
    memberList () {
      this.listLoading = true
      this.listQuery['pi'] = this.listQuery.page
      this.listQuery['ps'] = this.listQuery.limit
      memberList(this.listQuery).then(response => {
        this.listLoading = false
        const row = response.data
        if (row.data) {
          this.restaurants = row.data.items
          return row.data.items
        }
        return []
      })
    },
    getList () {
      this.listLoading = true
      this.listQuery['pi'] = this.listQuery.page
      this.listQuery['ps'] = this.listQuery.limit
      if (this.$route.query.memberId) {
        this.listQuery['memberId'] = this.$route.query.memberId
      }
      if (this.$route.query.companyId) {
        this.listQuery['companyId'] = this.$route.query.companyId
      }
      if (this.btime) {
        this.listQuery.beginTime = this.btime[0]
        this.listQuery.endTime = this.btime[1]
      }
      recordList(this.opType, this.listQuery).then(response => {
        const row = response.data
        if (row.data) {
          this.list = row.data.items
          this.total = row.data.totalItems
        }
        this.listLoading = false
      })
    },
    handleFilter () {
      if (this.opType === 'refund') {
        fetchTotalRefund(this.listQuery).then(resp => {
          if (!resp.data.data) {
            this.totalRefund = 0
          } else {
            this.totalRefund = resp.data.data
          }
        })
      } else if (this.opType === 'charge') {
        fetchTotalCharge(this.listQuery).then(resp => {
          this.totalCharge = resp.data.data.totalCharge
          this.cnt = resp.data.data.cnt
          this.totalGift = resp.data.data.totalGift
          console.log('gift====', this.totalGift)
        })
      }
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getList()
    },
    handleToExcel () {
      const type = this.opType
      let name = ''
      if (type === 'refund') {
        name = '退款'
      } else if (type === 'charge') {
        name = '充值'
      }
      let loadingIns
      this.$confirm('确定导出' + name + '记录为excel吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        loading: true,
        type: 'info'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          loadingIns = loading
          if (type === 'charge') {
            rechargeRecordToExcel(this.listQuery)
              .then(response => {
                if (response.data) {
                  const type = response.headers['content-type']
                  // response.setHeader("Content-Type", "application/vnd.ms-excel"); type必须和后端的type一致
                  downloadFile(response, type)
                  loadingIns.close()
                }
              })
              .catch(e => {
                this.$message({
                  type: 'warning',
                  message: '导出失败！ 原因：' + e
                })
                loadingIns.close()
              })
          } else if (type === 'refund') {
            refundRecordToExcel(this.listQuery)
              .then(response => {
                if (response.data) {
                  const type = response.headers['content-type']
                  // response.setHeader("Content-Type", "application/vnd.ms-excel"); type必须和后端的type一致
                  downloadFile(response, type)
                  loadingIns.close()
                }
              })
              .catch(e => {
                this.$message({
                  type: 'warning',
                  message: '导出失败！ 原因：' + e
                })
                loadingIns.close()
              })
          } else {
            return
          }
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '取消导出！'
          })
          loadingIns.close()
        })
    },
    changeVal (val) {
      switch (val) {
        case '1':
          this.btime = getDateOfDay(0)
          break
        case '2':
          this.btime = getYesterdayArr()
          break
        case '3':
          this.btime = getDateOfDay(-3)
          break
        case '4':
          this.btime = getDateOfDay(-7)
          break
        case '5':
          this.btime = getCurMonthRange()
          break
        default:
          this.btime = getDateOfDay(0)
          break
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.el-form-item__label {
  background-color: #909399;
}
.el-form-item__content span {
  padding: 0px 10px;
  display: inline-block;
}
.el-form-item__content span.one {
  width: 210px;
}
.el-form-item__content span.two {
  width: 180px;
}
</style>
